/**
 * Picks a language based field (example: "metatitle_et") from an api response object based on the current app language.
 */
export const getLocalizedField = (source: Record<string, unknown>, base: string, lang: string): string =>
    (source?.[`${base}_${lang}`] as string) || (source?.[`${base}_en`] as string) || '';
